export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="cf-logo-grad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3B82F6" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="12" fill="url(#cf-logo-grad)" />
    <path
      d="M30 14H17v20h5v-7h7v-5h-7v-3h8v-5z"
      fill="white"
    />
    <path d="M30 14h-2.5l-3.5 6h6V14z" fill="white" fillOpacity="0.55" />
  </svg>
);
